import React from 'react';
import styled from 'styled-components';
import { useChallenges } from '@members/copy/copy.generated';
import { Challenges } from '@members/copy/models.generated/Challenges';
import { SkipLinks } from '@members/copy/models.generated/SkipLinks';
import { LayoutWithoutUserNav } from '@members/layout/containers';
import Navbar, { CHALLENGES_NAV_ID } from './Navbar';

const CHALLENGES_CONTENT_ID = 'challenges-content';

const ChallengesPage: React.FC<React.PropsWithChildren<unknown>> = props => {
  return (
    <LayoutWithoutUserNav
      titleSegments={[useChallenges(Challenges.Title)]}
      skipLinks={{
        first: {
          skipLinkId: SkipLinks.SkipToChallengesNav,
          contentElementId: CHALLENGES_NAV_ID,
        },
        second: {
          skipLinkId: SkipLinks.SkipToContent,
          contentElementId: CHALLENGES_CONTENT_ID,
        },
      }}
    >
      <Navbar />
      <Main id={CHALLENGES_CONTENT_ID}>{props.children}</Main>
    </LayoutWithoutUserNav>
  );
};

const Main = styled.main`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export default ChallengesPage;
